import { toMapFn } from "../../utils/reducers";
import { CheckoutCountriesContextProvider } from "../components/CheckoutPage/CheckoutOptimeCountriesContext";
import { useOnMount } from "../../common/hooks/useOnMount";
import Spinner from "../../common/components/Spinner/Spinner";
import PageTitle from "~/common/components/PageTitle/v1/PageTitle";
import CheckoutCart from "../components/CheckoutPage/CheckoutCart";
import CheckoutFooter from "../components/CheckoutPage/CheckoutFooter";
import { type RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { checkoutPageMounted } from "../redux/actions/checkoutPageActions";
import { type DropdownEntry } from "~/common/types";

export function createCheckoutPage(data: { countriesJSON: string }) {
  const list: { isocode: string; name: string }[] = JSON.parse(data.countriesJSON);

  const countriesList: DropdownEntry<string>[] = list.map((item) => ({
    value: item.isocode,
    label: item.name,
    stringLabel: item.name,
  }));

  const countryByCode = toMapFn(
    list,
    (item) => item.isocode,
    (item) => item.name,
  );

  return (
    <CheckoutCountriesContextProvider value={{ countriesList, countryByCode }}>
      <CheckoutPage />
    </CheckoutCountriesContextProvider>
  );
}

const CheckoutPage = () => {
  const dispatch = useDispatch();
  useOnMount(() => dispatch(checkoutPageMounted()));

  const isLoading = useSelector(selectIsLoading);

  return (
    <>
      {/* TODO: remove extra padding and white background from root page container  */}
      {isLoading && <Spinner />}

      {!isLoading && (
        <>
          <CheckoutCart />

          <CheckoutFooter />
        </>
      )}
    </>
  );
};

const selectIsLoading = (state: RootState) => state.checkoutPage.loading;
